import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

import { ENTER } from 'approot/shared/ally/keyboard.hooks';

export const RichtextPreventNewLine = Extension.create({
  name: 'richtext_prevent_new_line',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('eventHandler'),
        props: {
          handleKeyDown: (_, event) => {
            if (event.key === ENTER && !event.shiftKey) {
              event.preventDefault();
              return true;
            }
            return false;
          },
        },
      }),
    ];
  },
});
